module.exports = "<div aria-hidden=\"true\" role=\"dialog\" class=\"\">\r\n    <div class=\"gw-pull-right gw-padded10 \" ng-click=\"close($event)\">\r\n        <span ><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></span>\r\n    </div>\r\n\r\n<br>\r\n<div class=\"gw-padded20\">{{'quoteandbind.view.make-payment.EPTMessage1' | translate}}</div>\r\n<div class=\"gw-padded20\">{{'quoteandbind.view.make-payment.EPTMessage2' | translate}}</div>\r\n\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/common/views/electronic-payment-terms-modal.html
 ** module id = 444
 ** module chunks = 0
 **/